import React, { useState } from "react";
import { FaFilePdf } from "react-icons/fa";
import { pyqsData } from "../../data/staticData";

export default function OptionalPyqs() {
  const [selectedYear, setSelectedYear] = useState("2023");
  const [activePdf, setActivePdf] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 5;
  const type = "Optional";

  const optionalData = pyqsData.filter(
    (item) => item.title.toLowerCase() === type.toLowerCase()
  );

  const availableYears = [...new Set(optionalData.map((item) => item.year))];

  const filteredData = optionalData.filter(
    (item) => item.year.toString() === selectedYear
  );

  const groupedData = Object.values(
    filteredData.reduce((acc, curr) => {
      if (!acc[curr.subject])
        acc[curr.subject] = { subject: curr.subject, files: [] };
      acc[curr.subject].files.push({
        name: `${curr.subject} Paper`,
        file: curr.filePath,
      });
      return acc;
    }, {})
  );

  const paginate = (items) => {
    const start = (currentPage - 1) * entriesPerPage;
    const end = start + entriesPerPage;
    return items.slice(start, end);
  };

  const handleViewPdf = (pdfUrl) => {
    if (pdfUrl) {
      setActivePdf(pdfUrl);
    } else {
      alert("PDF not available.");
    }
  };

  return (
    <section id="optional" className="w-full bg-gray-50 py-12 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-between items-center mb-8 gap-4">
          <h2 className="text-2xl sm:text-3xl font-bold text-red-800 text-center sm:text-left">
            Optional Examination PYQs
          </h2>

          <select
            value={selectedYear}
            onChange={(e) => {
              setSelectedYear(e.target.value);
              setCurrentPage(1);
            }}
            className="border border-red-700 text-red-800 rounded px-3 py-2 focus:outline-none"
          >
            {availableYears.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        {!groupedData.length ? (
          <div className="text-center py-10 text-gray-500">
            No Optional PYQs found.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {paginate(groupedData).map((paper, idx) => (
              <div
                key={idx}
                className="bg-white shadow-md rounded-lg p-6 border-l-4 border-blue-900 flex flex-col"
              >
                <h3 className="text-lg sm:text-xl font-semibold text-red-800 mb-4">
                  {paper.subject}
                </h3>
                <div className="grid grid-cols-1 gap-4">
                  {paper.files.map((doc, i) => (
                    <button
                      key={i}
                      onClick={() => handleViewPdf(doc.file)}
                      className="flex items-center p-4 border rounded-lg shadow-sm bg-gray-50 hover:bg-gray-100 transition w-full"
                    >
                      <FaFilePdf className="text-red-600 text-2xl mr-3 flex-shrink-0" />
                      <span className="font-medium text-gray-800 truncate">
                        {doc.name}
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        {activePdf && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-95 flex justify-center items-center p-2">
            <div className="absolute top-4 right-4">
              <button
                className="text-white text-3xl font-bold hover:text-red-500"
                onClick={() => setActivePdf(null)}
              >
                &times;
              </button>
            </div>
            <iframe
              src={activePdf}
              className="w-full h-full sm:h-[95vh] border-none"
              title="PDF Viewer"
            />
          </div>
        )}
      </div>
    </section>
  );
}
